module.exports = __webpack_public_path__ + "static/media/mike-desktop.20fac85d.png";